import React from "react";
import { StyledSearchLabel } from "./styled";
import { useContentStore } from "../../stores/contentStore";
import { useFolderStore } from "../../stores/folderStore";

const SearchLabel = () => {
  const searchKeywordTemp = useContentStore(
    (state: any) => state.searchKeywordTemp,
  );
  const folderId = useFolderStore((state: any) => state.folderId);
  const openFolderName = useFolderStore((state: any) => state.openFolderName);

  return (
    <StyledSearchLabel>
      Search results for "{searchKeywordTemp}"
      {folderId !== 1 && ` in ${JSON.stringify(openFolderName)}`}
    </StyledSearchLabel>
  );
};

export default SearchLabel;
